import { categorizeOrders, prepareMeetingInfo, prepareRawBookingDetail } from '../../helpers/functions/booking'
import { MEETING, MODAL, ROOM } from '..'
import apiService from '../apiService'
import { ORDER_TYPE } from '../../helpers'
import { isEmpty } from 'lodash'

export const getBookingDetailById = (bookingId) => {
  return async (dispatch, getState) => {
    try {
      const bookingResponse = await apiService.get('rest/v1/getdetail_booking', bookingId)
      const language = getState().accountReducer.language

      const categorizedOrder = categorizeOrders(bookingResponse.data.orders)

      if (bookingResponse) {
        const bookingDetail = prepareMeetingInfo(bookingResponse.data, language)
        const rawBookingDetail = prepareRawBookingDetail(bookingResponse.data)

        const allDetail = {
          bookingDetail,
          cateringList: [
            ...(!isEmpty(categorizedOrder[ORDER_TYPE.DRINK.VALUE]) ? categorizedOrder[ORDER_TYPE.DRINK.VALUE] : []),
            ...(!isEmpty(categorizedOrder[ORDER_TYPE.FOOD.VALUE]) ? categorizedOrder[ORDER_TYPE.FOOD.VALUE] : []),
          ],
          equipmentList: [
            ...(!isEmpty(categorizedOrder[ORDER_TYPE.EQUIPMENT.VALUE]) ? categorizedOrder[ORDER_TYPE.EQUIPMENT.VALUE] : []),
          ],
          rawBookingDetail,
        }

        const { roomId } = bookingDetail
        
        await dispatch(setAllBookingDetail({ ...allDetail }))
        await dispatch(ROOM.action.getDetailRoom({ roomId }))
      } else {
        dispatch(MODAL.action.openModalStatus(bookingResponse))
      }
    } catch (error) {
      console.error('getBookingDetailById ERROR :: ', error)
    }
  }
}

export const resetAllMeetingInfo = () => dispatch => {
  dispatch({
    type: MEETING.actionType.RESET_ALL_MEETING_INFO,
  })
}

export const setBookingDetail = (data) => {
  return {
    type: MEETING.actionType.SET_BOOKING_DETAIL,
    data,
  }
}

export const setAllBookingDetail = (data) => {
  return {
    type: MEETING.actionType.SET_ALL_BOOKING_DETAIL,
    data,
  }
}
